import React, { useState } from 'react'
import { Button } from '../../../../../../../components/Button/Button'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'
import {
  selectIsExecutionLoading,
  setPollingManuallyExecutedAiFeatureId,
  startExecutedAiFeaturesPolling,
} from '../../../../../../../store/meetingSummary/executedAiFeatures'
import { useExecuteAiFeatures } from '../../../hooks/api'
import { MissingScopeAction } from '../../../../../../../components/ScopedBlock/models'
import { ScopedBlock } from '../../../../../../../components/ScopedBlock/ScopedBlock'
import { TrackEvent, useTracking } from '../../../../common/tracking'
import { getRoomAndAIFeatureTrackingDetails } from '../../../../tracking'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { selectRoomSession, selectRoomSessionHasTranscription } from '../../../../../../../store/meetingSummary/roomSession'
import { selectSelectedMeetingTemplate } from '../../../../../../../store/meetingSummary/meetingTemplates'
import classnames from 'classnames'
import { Tooltip } from '../../../../../../../components/Tooltip/Tooltip'

export interface ManuallyRunnableAiFeatureProps {
  aiFeature: AiFeature
}

export const ManuallyRunnableAiFeature: React.FC<ManuallyRunnableAiFeatureProps> = ({ aiFeature }) => {
  const dispatch = useAppDispatch()
  const { tracked } = useTracking()
  const hasTranscription = useAppSelector(selectRoomSessionHasTranscription)
  const roomSession = useAppSelector(selectRoomSession)
  const selectedMeetingTemplate = useAppSelector(selectSelectedMeetingTemplate)
  const isLoadingExecutedAiFeatures = useAppSelector(selectIsExecutionLoading)

  const executeAiFeatures = useExecuteAiFeatures()

  const [loading, setLoading] = useState<boolean>(false)

  if (!selectedMeetingTemplate) {
    return null
  }

  const { id: aiFeatureId } = aiFeature

  const _handleRun = () => {
    setLoading(true)
    executeAiFeatures([aiFeatureId], selectedMeetingTemplate.id)
    dispatch(setPollingManuallyExecutedAiFeatureId(aiFeatureId))
    dispatch(startExecutedAiFeaturesPolling())
  }

  const handleRun = tracked(_handleRun, {
    eventName: TrackEvent.AI_FEATURE_MANUAL_RUN,
    eventDetails: getRoomAndAIFeatureTrackingDetails(roomSession, aiFeature),
  })

  return (
    <div className='no-result-container d-flex p-3 gap-2 align-items-center'>
      <ScopedBlock
        scope={{
          scope: 'aifeature:execute',
          superScope: ['aifeature:admin'],
        }}
        missingScopeAction={MissingScopeAction.DISABLE}
      >
        <Tooltip title={!hasTranscription ? 'Meeting has no transcription' : undefined}>
          <Button variant='primary' className='py-1 px-2' onClick={handleRun} disabled={isLoadingExecutedAiFeatures || loading || !hasTranscription}>
            <i
              className={classnames('bi bi-arrow-repeat', {
                'spin-faster': loading,
              })}
            ></i>
            Run
          </Button>
        </Tooltip>
      </ScopedBlock>
      <span className='paragraph-medium'> the preset to view results</span>
    </div>
  )
}
